import React, { useState, useEffect } from 'react';
import './AboutManager.css';
import { getAboutSettings, updateAboutSettings } from '../../firebase/dataService';

function AboutManager() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [settings, setSettings] = useState({
    visible: true,
    pageTitle: 'عن الشيخ',
    profile: {
      enabled: true,
      name: 'سلمان بن عبدالله الحران',
      description: 'طالب علم متخصص في العلوم الشرعية، يسعى لنشر الفائدة والعلم النافع من خلال هذه السلسلة المباركة.'
    },
    series: {
      enabled: true,
      title: 'سلسلة الفوائد',
      description: 'سلسلة تعليمية تهدف إلى نشر الفوائد العلمية والمسائل الشرعية المختصرة في مختلف أبواب العلم الشرعي، في مواضيع متنوعة من الفقه والعقيدة والحديث والتفسير وغيرها.'
    },
    goals: {
      enabled: true,
      title: 'الأهداف',
      items: [
        'نشر العلم الشرعي الصحيح',
        'تبسيط المسائل العلمية للعامة',
        'توفير محتوى علمي موثوق ومختصر',
        'خدمة طلاب العلم والباحثين'
      ]
    },
    topics: {
      enabled: true,
      title: 'المجالات',
      items: ['العقيدة', 'الفقه', 'الحديث', 'التفسير', 'السيرة النبوية', 'الآداب والأخلاق']
    },
    contact: {
      enabled: true,
      title: 'تواصل معنا',
      twitter: 'https://x.com/salman_alKhatep',
      youtube: 'https://youtube.com/channel/UCJCc6TojI38et5ckeUikRWg?si=SV2ju6GjGLgrKHTB',
      telegram: 'https://t.me/salman_alkhatep'
    }
  });

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      setLoading(true);
      const data = await getAboutSettings();
      if (data) {
        setSettings(data);
      }
    } catch (error) {
      console.error('Error loading about settings:', error);
      setMessage({ type: 'error', text: 'فشل تحميل الإعدادات' });
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      setMessage({ type: '', text: '' });
      
      await updateAboutSettings(settings);
      
      setMessage({ type: 'success', text: '✅ تم حفظ التعديلات بنجاح!' });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
    } catch (error) {
      console.error('Error saving settings:', error);
      setMessage({ type: 'error', text: '❌ فشل حفظ التعديلات' });
    } finally {
      setSaving(false);
    }
  };

  const handleToggleVisibility = async () => {
    const newSettings = { ...settings, visible: !settings.visible };
    setSettings(newSettings);
    
    try {
      await updateAboutSettings(newSettings);
      setMessage({ 
        type: 'success', 
        text: newSettings.visible ? '✅ تم إظهار صفحة عن الشيخ' : '✅ تم إخفاء صفحة عن الشيخ'
      });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
    } catch (error) {
      console.error('Error toggling visibility:', error);
      setSettings(settings);
      setMessage({ type: 'error', text: '❌ فشل تغيير حالة الظهور' });
    }
  };

  const handleGoalChange = (index, value) => {
    const newGoals = [...settings.goals.items];
    newGoals[index] = value;
    setSettings({
      ...settings,
      goals: { ...settings.goals, items: newGoals }
    });
  };

  const addGoal = () => {
    setSettings({
      ...settings,
      goals: { ...settings.goals, items: [...settings.goals.items, ''] }
    });
  };

  const removeGoal = (index) => {
    const newGoals = settings.goals.items.filter((_, i) => i !== index);
    setSettings({
      ...settings,
      goals: { ...settings.goals, items: newGoals }
    });
  };

  const handleTopicChange = (index, value) => {
    const newTopics = [...settings.topics.items];
    newTopics[index] = value;
    setSettings({
      ...settings,
      topics: { ...settings.topics, items: newTopics }
    });
  };

  const addTopic = () => {
    setSettings({
      ...settings,
      topics: { ...settings.topics, items: [...settings.topics.items, ''] }
    });
  };

  const removeTopic = (index) => {
    const newTopics = settings.topics.items.filter((_, i) => i !== index);
    setSettings({
      ...settings,
      topics: { ...settings.topics, items: newTopics }
    });
  };

  if (loading) {
    return (
      <div className="loading-state">
        <div className="spinner-large"></div>
        <p>جاري تحميل الإعدادات...</p>
      </div>
    );
  }

  return (
    <div className="about-manager">
      <div className="manager-header">
        <div className="header-actions">
          <button 
            className={`visibility-toggle ${settings.visible ? 'visible' : 'hidden'}`}
            onClick={handleToggleVisibility}
          >
            {settings.visible ? (
              <>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginLeft: '6px' }}>
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                الصفحة ظاهرة
              </>
            ) : (
              <>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginLeft: '6px' }}>
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                  <line x1="1" y1="1" x2="23" y2="23"></line>
                </svg>
                الصفحة مخفية
              </>
            )}
          </button>
          <button 
            className="save-button"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? (
              <>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginLeft: '6px', animation: 'spin 1s linear infinite' }}>
                  <line x1="12" y1="2" x2="12" y2="6"></line>
                  <line x1="12" y1="18" x2="12" y2="22"></line>
                  <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
                  <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
                  <line x1="2" y1="12" x2="6" y2="12"></line>
                  <line x1="18" y1="12" x2="22" y2="12"></line>
                  <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
                  <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
                </svg>
                جاري الحفظ...
              </>
            ) : (
              <>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginLeft: '6px' }}>
                  <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
                  <polyline points="17 21 17 13 7 13 7 21"></polyline>
                  <polyline points="7 3 7 8 15 8"></polyline>
                </svg>
                حفظ التعديلات
              </>
            )}
          </button>
        </div>
        
        {message.text && (
          <div className={`message ${message.type}`}>
            {message.text}
          </div>
        )}
      </div>

      <div className="settings-sections">
        <div className="settings-section">
          <h3 className="section-title">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginLeft: '6px' }}>
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
            </svg>
            عنوان الصفحة
          </h3>
          <div className="form-group">
            <label>عنوان الصفحة</label>
            <input
              type="text"
              value={settings.pageTitle}
              onChange={(e) => setSettings({ ...settings, pageTitle: e.target.value })}
              placeholder="عن الشيخ"
            />
          </div>
        </div>

        <div className="settings-section">
          <div className="section-header-with-toggle">
            <h3 className="section-title">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginLeft: '6px' }}>
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              الملف الشخصي
            </h3>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={settings.profile?.enabled !== false}
                onChange={(e) => setSettings({
                  ...settings,
                  profile: { ...settings.profile, enabled: e.target.checked }
                })}
              />
              <span className="toggle-slider"></span>
              <span className="toggle-label">{settings.profile?.enabled !== false ? 'مفعّل' : 'معطّل'}</span>
            </label>
          </div>
          <div className="form-group">
            <label>الاسم</label>
            <input
              type="text"
              value={settings.profile?.name || ''}
              onChange={(e) => setSettings({
                ...settings,
                profile: { ...settings.profile, name: e.target.value }
              })}
              placeholder="سلمان بن عبدالله الحران"
            />
          </div>
          <div className="form-group">
            <label>الوصف</label>
            <textarea
              value={settings.profile?.description || ''}
              onChange={(e) => setSettings({
                ...settings,
                profile: { ...settings.profile, description: e.target.value }
              })}
              placeholder="وصف مختصر"
              rows="3"
            />
          </div>
        </div>

        <div className="settings-section">
          <div className="section-header-with-toggle">
            <h3 className="section-title">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginLeft: '6px' }}>
                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
              </svg>
              سلسلة الفوائد
            </h3>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={settings.series?.enabled !== false}
                onChange={(e) => setSettings({
                  ...settings,
                  series: { ...settings.series, enabled: e.target.checked }
                })}
              />
              <span className="toggle-slider"></span>
              <span className="toggle-label">{settings.series?.enabled !== false ? 'مفعّل' : 'معطّل'}</span>
            </label>
          </div>
          <div className="form-group">
            <label>العنوان</label>
            <input
              type="text"
              value={settings.series?.title || ''}
              onChange={(e) => setSettings({
                ...settings,
                series: { ...settings.series, title: e.target.value }
              })}
              placeholder="سلسلة الفوائد"
            />
          </div>
          <div className="form-group">
            <label>الوصف</label>
            <textarea
              value={settings.series?.description || ''}
              onChange={(e) => setSettings({
                ...settings,
                series: { ...settings.series, description: e.target.value }
              })}
              placeholder="وصف السلسلة"
              rows="4"
            />
          </div>
        </div>

        <div className="settings-section">
          <div className="section-header-with-toggle">
            <h3 className="section-title">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginLeft: '6px' }}>
                <circle cx="12" cy="12" r="10"></circle>
                <circle cx="12" cy="12" r="6"></circle>
                <circle cx="12" cy="12" r="2"></circle>
              </svg>
              الأهداف
            </h3>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={settings.goals?.enabled !== false}
                onChange={(e) => setSettings({
                  ...settings,
                  goals: { ...settings.goals, enabled: e.target.checked }
                })}
              />
              <span className="toggle-slider"></span>
              <span className="toggle-label">{settings.goals?.enabled !== false ? 'مفعّل' : 'معطّل'}</span>
            </label>
          </div>
          <div className="form-group">
            <label>عنوان القسم</label>
            <input
              type="text"
              value={settings.goals?.title || ''}
              onChange={(e) => setSettings({
                ...settings,
                goals: { ...settings.goals, title: e.target.value }
              })}
              placeholder="الأهداف"
            />
          </div>
          <div className="form-group">
            <label>الأهداف</label>
            {settings.goals?.items.map((goal, index) => (
              <div key={index} className="list-item-input">
                <input
                  type="text"
                  value={goal}
                  onChange={(e) => handleGoalChange(index, e.target.value)}
                  placeholder={`الهدف ${index + 1}`}
                />
                <button 
                  className="remove-btn"
                  onClick={() => removeGoal(index)}
                  type="button"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            ))}
            <button className="add-btn" onClick={addGoal} type="button">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginLeft: '4px' }}>
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              إضافة هدف
            </button>
          </div>
        </div>

        <div className="settings-section">
          <div className="section-header-with-toggle">
            <h3 className="section-title">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginLeft: '6px' }}>
                <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
              </svg>
              المجالات
            </h3>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={settings.topics?.enabled !== false}
                onChange={(e) => setSettings({
                  ...settings,
                  topics: { ...settings.topics, enabled: e.target.checked }
                })}
              />
              <span className="toggle-slider"></span>
              <span className="toggle-label">{settings.topics?.enabled !== false ? 'مفعّل' : 'معطّل'}</span>
            </label>
          </div>
          <div className="form-group">
            <label>عنوان القسم</label>
            <input
              type="text"
              value={settings.topics?.title || ''}
              onChange={(e) => setSettings({
                ...settings,
                topics: { ...settings.topics, title: e.target.value }
              })}
              placeholder="المجالات"
            />
          </div>
          <div className="form-group">
            <label>المجالات</label>
            {settings.topics?.items.map((topic, index) => (
              <div key={index} className="list-item-input">
                <input
                  type="text"
                  value={topic}
                  onChange={(e) => handleTopicChange(index, e.target.value)}
                  placeholder={`المجال ${index + 1}`}
                />
                <button 
                  className="remove-btn"
                  onClick={() => removeTopic(index)}
                  type="button"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            ))}
            <button className="add-btn" onClick={addTopic} type="button">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginLeft: '4px' }}>
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              إضافة مجال
            </button>
          </div>
        </div>

        <div className="settings-section">
          <div className="section-header-with-toggle">
            <h3 className="section-title">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginLeft: '6px' }}>
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
              قسم التواصل
            </h3>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={settings.contact?.enabled !== false}
                onChange={(e) => setSettings({
                  ...settings,
                  contact: { ...settings.contact, enabled: e.target.checked }
                })}
              />
              <span className="toggle-slider"></span>
              <span className="toggle-label">{settings.contact?.enabled !== false ? 'مفعّل' : 'معطّل'}</span>
            </label>
          </div>
          <div className="form-group">
            <label>عنوان القسم</label>
            <input
              type="text"
              value={settings.contact?.title || ''}
              onChange={(e) => setSettings({
                ...settings,
                contact: { ...settings.contact, title: e.target.value }
              })}
              placeholder="تواصل معنا"
            />
          </div>
          <div className="form-group">
            <label>رابط Twitter</label>
            <input
              type="url"
              value={settings.contact?.twitter || ''}
              onChange={(e) => setSettings({
                ...settings,
                contact: { ...settings.contact, twitter: e.target.value }
              })}
              placeholder="https://x.com/username"
            />
          </div>
          <div className="form-group">
            <label>رابط YouTube</label>
            <input
              type="url"
              value={settings.contact?.youtube || ''}
              onChange={(e) => setSettings({
                ...settings,
                contact: { ...settings.contact, youtube: e.target.value }
              })}
              placeholder="https://youtube.com/..."
            />
          </div>
          <div className="form-group">
            <label>رابط Telegram</label>
            <input
              type="url"
              value={settings.contact?.telegram || ''}
              onChange={(e) => setSettings({
                ...settings,
                contact: { ...settings.contact, telegram: e.target.value }
              })}
              placeholder="https://t.me/username"
            />
          </div>
        </div>
      </div>

      <div className="manager-footer">
        <button 
          className="save-button-large"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? (
            <>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginLeft: '6px', animation: 'spin 1s linear infinite' }}>
                <line x1="12" y1="2" x2="12" y2="6"></line>
                <line x1="12" y1="18" x2="12" y2="22"></line>
                <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
                <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
                <line x1="2" y1="12" x2="6" y2="12"></line>
                <line x1="18" y1="12" x2="22" y2="12"></line>
                <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
                <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
              </svg>
              جاري الحفظ...
            </>
          ) : (
            <>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginLeft: '6px' }}>
                <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
                <polyline points="17 21 17 13 7 13 7 21"></polyline>
                <polyline points="7 3 7 8 15 8"></polyline>
              </svg>
              حفظ جميع التعديلات
            </>
          )}
        </button>
      </div>
    </div>
  );
}

export default AboutManager;
